import { useReduxSelector } from 'hooks';

export default function useAuthToken() {
  return useReduxSelector((state) => state.authentication).token;
}
